/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Draft_TitleInputs */

const en_us2_coaching_draft_title = /** @type {(inputs: Coaching_Draft_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft waiting for your approval`)
};

const pt_br2_coaching_draft_title = /** @type {(inputs: Coaching_Draft_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rascunho esperando sua aprovação`)
};

const pt_pt2_coaching_draft_title = /** @type {(inputs: Coaching_Draft_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rascunho esperando sua aprovação`)
};

/** @type {(inputs: Coaching_Draft_TitleInputs) => LocalizedString} */
const es_419_coaching_draft_title = en_us2_coaching_draft_title;

/** @type {(inputs: Coaching_Draft_TitleInputs) => LocalizedString} */
const fr_fr2_coaching_draft_title = en_us2_coaching_draft_title;

/** @type {(inputs: Coaching_Draft_TitleInputs) => LocalizedString} */
const de_de2_coaching_draft_title = en_us2_coaching_draft_title;

/** @type {(inputs: Coaching_Draft_TitleInputs) => LocalizedString} */
const it_it2_coaching_draft_title = en_us2_coaching_draft_title;

/**
* | output |
* | --- |
* | "Draft waiting for your approval" |
*
* @param {Coaching_Draft_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_draft_title = /** @type {((inputs?: Coaching_Draft_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Draft_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_draft_title(inputs)
	if (locale === "es-419") return es_419_coaching_draft_title(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_draft_title(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_draft_title(inputs)
	if (locale === "de-DE") return de_de2_coaching_draft_title(inputs)
	if (locale === "it-IT") return it_it2_coaching_draft_title(inputs)
	return en_us2_coaching_draft_title(inputs)
});
export { coaching_draft_title as "coaching.draft_title" }